module.exports = __webpack_public_path__ + "img/clear.1c425ea8.svg";